'use client';

import { useEffect } from 'react';

/**
 * Rede de segurança além do deploymentId nativo do Next:
 * se a aba ficou aberta durante um build/restart, recarrega
 * ao voltar o foco (antes do utilizador clicar e ver Flight cru).
 */
export default function DeploymentSkewGuard() {
  useEffect(() => {
    let busy = false;

    async function check() {
      if (busy || typeof document === 'undefined') return;
      const clientId = document.documentElement.getAttribute('data-dpl-id');
      if (!clientId) return;

      busy = true;
      try {
        const res = await fetch('/api/deployment-id/', {
          cache: 'no-store',
          credentials: 'same-origin',
        });
        if (!res.ok) return;
        const data = await res.json();
        const serverId = data?.id;
        if (serverId && serverId !== clientId) {
          window.location.reload();
        }
      } catch {
        // offline / restart a meio — ignora
      } finally {
        busy = false;
      }
    }

    function onVisible() {
      if (document.visibilityState === 'visible') check();
    }

    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', onVisible);
    const interval = window.setInterval(check, 120_000);

    return () => {
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', onVisible);
      window.clearInterval(interval);
    };
  }, []);

  return null;
}
